// Deps
import { useState, useEffect, useRef } from 'react'

const useVisible = (show, timeout = 600, delayEntrance = false) => {
	const [inDom, setInDom] = useState(delayEntrance ? false : show);
	const [visible, setVisible] = useState(delayEntrance ? false : show);

	const timer = useRef(false);
	const _mounted = useRef(false);

	useEffect(() => {
		_mounted.current = true;

		return () => {
			_mounted.current = false;
		}
	}, [])

	useEffect(() => {
		if (show && !inDom) {
			if (timer.current) { clearTimeout(timer.current); }

			setInDom(true);
			timer.current = setTimeout(() => {
				if (_mounted.current) {
					setVisible(true);
				}
			}, 35)
		}
		else if (!show && inDom && visible) {
			if (timer.current) { clearTimeout(timer.current); }

			setVisible(false);
			timer.current = setTimeout(() => {
				if (_mounted.current) {
					setInDom(false);
				}
			}, timeout)
		}
	}, [show, inDom, timeout, visible, delayEntrance])

	return [inDom, visible];
}

export default useVisible;